export default __webpack_public_path__ + "static/media/favicon.d19bc836.ico";